"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constants = {
  LOGIN_REDIRECT_URL_WHITE_LISTING_REGEX_TOYOTA: /^https:\/\/(test|stage)*\.*account\.toyota\.com/,
  LOGIN_REDIRECT_URL_WHITE_LISTING_REGEX_LEXUS: /^https:\/\/(test|stage)*\.*account\.lexus\.com/,
  LOGIN_REDIRECT_URL_WHITE_LISTING_REGEX_SAML: /^(https:|http:)\/\/(login)\.(qa-tmna|stg-tmna|tmna)\.toyotadriverslogin\.com/
};
exports.logoutURLRegexToyota = ["^https:\/\/api\.(dev|test|stage|demo)*\.*dg\.toyota\.com", "(toyota|toyotaowners|toyotafinancial)\.com"];
exports.logoutURLRegexLexus = ["^https:\/\/api\.(dev|test|stage|demo)*\.*dg\.toyota\.com", "(lexus|lexusfinancial)\.com"];
exports.goToURLRegexToyota = new RegExp(exports.constants.LOGIN_REDIRECT_URL_WHITE_LISTING_REGEX_TOYOTA);
exports.goToURLRegexLexus = new RegExp(exports.constants.LOGIN_REDIRECT_URL_WHITE_LISTING_REGEX_LEXUS);
exports.goToURLRegexSAML = new RegExp(exports.constants.LOGIN_REDIRECT_URL_WHITE_LISTING_REGEX_SAML);